import { useI18n } from '@affine/i18n';
import { useMemo } from 'react';

import { getCurrentFydeOSBrandLinks } from '../product-brand';

export const useNavConfig = () => {
  const t = useI18n();
  const brandLinks = getCurrentFydeOSBrandLinks();
  return useMemo(
    () => [
      {
        title: t['com.affine.other-page.nav.official-website'](),
        path: brandLinks.website,
      },
      {
        title: t['com.affine.other-page.nav.blog'](),
        path: brandLinks.updates,
      },
      {
        title: t['com.affine.other-page.nav.contact-us'](),
        path: brandLinks.help,
      },
    ],
    [brandLinks.help, brandLinks.updates, brandLinks.website, t]
  );
};
